import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { UserFormModal } from "../components/UserFormModal";
import { UserTable } from "../components/UserTable";
import { useUsersStore } from "../store/users.store";

export function UsersPage() {
	const openCreateModal = useUsersStore((s) => s.openCreateModal);

	return (
		<div>
			<PageHeader
				title="Foydalanuvchilar"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={openCreateModal}
						id="users-create-btn"
					>
						Qo'shish
					</Button>
				}
			/>
			<UserTable />
			<UserFormModal />
		</div>
	);
}
